module.exports = __webpack_public_path__ + "assets/d67a62bb55abf438097b2b4289a098d5.mp3";